export default __webpack_public_path__ + "static/jaeger-36bd6bcf9d76fb295e8ed3a1f6f4c406.webp";